﻿window.cScreenRecorder = function (nameFinal, saveSound, bddRef) {

    let mediaRecorder = null;
    let recordedChunks = [];
    if (typeof saveSound == 'undefined') saveSound = false

    this.start = function () {

        if (saveSound) {
            navigator.mediaDevices.getDisplayMedia({ video: true })
                .then(function (screenStream) {
                    navigator.mediaDevices.getUserMedia({ audio: true })
                        .then(function (audioStream) {
                            const combinedStream = new MediaStream([
                                ...screenStream.getVideoTracks(),
                                ...audioStream.getAudioTracks()
                            ]);

                            $PreviewVideo[0].srcObject = combinedStream;

                            recordedChunks = [];
                            mediaRecorder = new MediaRecorder(combinedStream);

                            mediaRecorder.ondataavailable = function (e) {
                                if (e.data.size > 0) recordedChunks.push(e.data);
                            };

                            mediaRecorder.onstop = function () {
                                $TdStopVideo.hide()
                                $TdPreviewVideo.hide()
                                mSave()
                            };

                            mediaRecorder.start();
                        })
                        .catch(function (err) {
                            alert("Erreur audio : " + err.message);
                            $TdStopVideo.hide()
                            $TdPreviewVideo.hide()
                        });
                })
                .catch(function (err) {
                    alert("Erreur vidéo : " + err.message);
                    $TdStopVideo.hide()
                    $TdPreviewVideo.hide()
                });
        } else {
            navigator.mediaDevices.getDisplayMedia({ video: true })
                .then(function (screenStream) {
                    const combinedStream = new MediaStream([
                        ...screenStream.getVideoTracks()
                    ]);

                    $PreviewVideo[0].srcObject = combinedStream;

                    recordedChunks = [];
                    mediaRecorder = new MediaRecorder(combinedStream);

                    mediaRecorder.ondataavailable = function (e) {
                        if (e.data.size > 0) recordedChunks.push(e.data);
                    };

                    mediaRecorder.onstop = function () {
                        $TdStopVideo.hide()
                        $TdPreviewVideo.hide()
                        mSave()
                    };

                    mediaRecorder.start();
                })
                .catch(function (err) {
                    alert("Erreur vidéo : " + err.message);
                    $TdStopVideo.hide()
                    $TdPreviewVideo.hide()
                });
        }

    }

    function mSave() {
        const blob = new Blob(recordedChunks, { type: "video/webm" });
        const url = URL.createObjectURL(blob);

        var popup = $("<div/>").appendTo("body").dxCtrlPopupBase({
            fullScreen: false,
            showMaximize: false,
            height: "auto",
            width: 500,
            contentTemplate: function (contentElement) {
                contentElement.css("text-align", "center")
                contentElement.css("padding-top", "0")
                var $Video = $("<video id='preview' autoplay muted style='width:400px;display:inline-block;'></video>").appendTo(contentElement)

                $Video.attr('src', url);
                $("<br/>").appendTo(contentElement)
                $("<br/>").appendTo(contentElement)
                $("<br/>").appendTo(contentElement)

                var $Table = $("<table style='width:100%'/>").appendTo(contentElement)
                var $Tr = $("<tr/>").appendTo($Table)
                var $Td = $("<td style='width:50%'/>").appendTo($Table)
                var $Td = $("<td style='width:1px;padding-right:5px;'/>").appendTo($Table)
                $("<div/>").appendTo($Td).dxCtrlButton({
                    text: "Télécharger",
                    hint: "Télécharger la vidéo sur votre ordinateur",
                    onClick: function (e) {
                        mSaveSurServeur(blob, function (urlFile) {
                            const a = document.createElement('a');
                            a.style.display = 'none';
                            a.href = urlFile;
                            a.download = 'capture_ecran.webm';
                            document.body.appendChild(a);
                            a.click();
                            URL.revokeObjectURL(url);
                            mNotify("Votre vidéo a été téléchargée sur votre ordinateur.", "success", 6000)
                        })
                        //const a = document.createElement('a');
                        //a.style.display = 'none';
                        //a.href = url;
                        //a.download = 'capture_ecran.webm';
                        //document.body.appendChild(a);
                        //a.click();
                        //URL.revokeObjectURL(url);
                        //mNotify("Votre vidéo a été téléchargé sur votre ordinateur.", "success", 6000)
                    }
                })
                var $Td = $("<td style='width:1px;padding-right:5px;'/>").appendTo($Table)
                $("<div/>").appendTo($Td).dxCtrlButton({
                    text: "Joindre à un ticket de support",
                    hint: "Créer un ticket de support avec la vidéo jointe",
                    onClick: function (e) {
                        mSaveSurServeur(blob, function (urlFile) {
                            jaugeDemarrage.option("message", "Création de votre ticket")
                            page.dxMenuLeft.mShowSupport(null, true, [urlFile], function () {
                                jaugeDemarrage.mHide()
                                jaugeDemarrage.option("message", "")
                                popup.hide()
                            })
                        })
                    }
                })
                var $Td = $("<td style='width:50%'/>").appendTo($Table)

                $("<br/>").appendTo(contentElement)

            }
        }).dxCtrlPopupBase("instance")
        popup.show()
        mediaRecorder = null
        recordedChunks = []
    }

    this.stop = function () {
        if (mediaRecorder) {
            mediaRecorder.stop();
        }
    }

    function mSaveSurServeur(blob, funcOk, funcKo) {
        jaugeDemarrage.mShow()
        console.log("Taille de la vidéo :", blob.size, "octets");
        mTraiteMessageJs("messagejs", "Upload vidéo support " + (blob.size / 1024 / 1024) + "Mo", $(location).attr("href"), 0, null, null, "orange")
        const formData = new FormData();
        var pathTempUpload = ""
        formData.append("video", blob, nameFinal + ".webm");
        bddRef.mAjaxCall({ command: "getpathvirtueltemporaire" }, function (data) {
            pathTempUpload = data.path;
            $.ajax({
                url: '/ext/handlerexterne.ashx?command=handlerupload&nom_base=' + parametre.code_appli + '_aagest&dest=' + encodeURI(pathTempUpload) + "&makeseekable=0",
                type: "POST",
                data: formData,
                processData: false,
                contentType: false,
                xhr: function () {
                    var xhr = new window.XMLHttpRequest();
                    // Suivi de la progression de l'envoi
                    xhr.upload.addEventListener("progress", function (evt) {
                        jaugeDemarrage.mAvance("Envoi de votre vidéo sur le serveur", evt.loaded, evt.total)
                    }, false);
                    return xhr;
                },
                success: function (response) {
                    console.log("Réponse du serveur :", response);
                    mediaRecorder = null
                    recordedChunks = []
                    if (typeof funcOk != 'undefined') {
                        funcOk(pathTempUpload + "/" + nameFinal + ".webm")
                    }
                    else {
                        jaugeDemarrage.mHide()
                        jaugeDemarrage.option("message", "")
                        mNotify("Votre vidéo a été envoyé sur le serveur.", "success", 6000)
                    }
                },
                error: function (xhr, status, error) {
                    console.error("Erreur : ", error);
                    mNotify("Votre vidéo n'a pas pu être sauvegarder.", "error", 6000)
                    jaugeDemarrage.mHide()
                    mediaRecorder = null
                    recordedChunks = []
                    if (typeof funcKo != 'undefined') funcKo()
                }
            });
        });

    }

}